import { Component, input } from '@angular/core';
import { SafeHtmlPipe } from "../../../shared/pipes/safe-html.pipe";


import { Result } from 'aisearch-search-fe-library';

@Component({
  selector: 'app-results',
  templateUrl: './results.component.html',
  imports: [SafeHtmlPipe]
})
export class ResultsComponent {
  readonly searchResults = input.required<Result[]>();

  openFileLink(encodedUrl: string) {
    window.open(encodedUrl, '_blank');
  }
}
